import {
  entries,
  filter,
  flatMap,
  isPlainObject,
  map,
  pipe,
} from '@vestigas/utils';

import { type DeliveryNoteAssetMainOrChain } from '../types';

/**
 * Returns the billed line items for the delivery note.
 * @param deliveryNote - The delivery note to get the billed items from.
 * @returns The billed items.
 */
export const getBilledItems = (deliveryNote: DeliveryNoteAssetMainOrChain) => {
  if (!isPlainObject(deliveryNote?.billedItems)) {
    return [];
  }

  const billedItems = pipe(
    deliveryNote.billedItems,
    entries,
    flatMap(([billingParty, billedByPartyItems]) =>
      map(
        billedByPartyItems ?? [],
        ({
          billingDetails,
          lineItemIndex,
          name,
          sellerAssignedId,
          totalBilledQuot,
        }) => ({
          billingDetails,
          billingParty,
          lineItemIndex,
          name,
          sellerAssignedId,
          totalBilledQuotient: (() => {
            const n = Number.parseFloat(totalBilledQuot ?? '0');

            return Number.isFinite(n) ? Math.max(0, n) : 0;
          })(),
        }),
      ),
    ),
    filter(Boolean),
  );

  return billedItems;
};
